import React from 'react'
import AnonymousView from '../anonymous-view'

const AnonymousViewPt = () => {
    return <AnonymousView languageCode="pt" />
}

export default AnonymousViewPt
